import {
  Button,
  Card,
  Col,
  Flex,
  Progress,
  Row,
  Select,
  Table,
  Tag,
} from "antd";
import classes from "./Dashboard.module.scss";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  DragOutlined,
} from "@ant-design/icons";
import BarChart from "./BarChart";
import RadialBarChart from "./RadialBarChart";
import AreaChart from "./AreaCharts";
import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import PolarChart from "./PolarChart";
import CompetitorTrendChart from "./CompetitorTrendChart";
import MarketSentimentChart from "./MarketSentimentChart";
import EmergingTrendsChart from "./EmergingTrendsChart";
import HeatmapChart from "./HeatmapChart";
import { columns, dataSource } from "./constants";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { formatToTrillions } from "../../helpers";
import RiskSummaryChart from "./RiskSummaryChart";
import OpportunitySummaryChart from "./OpportunitySummaryChart";
import FinancialSummaryChart from "./FinancialSummaryChart";
import ImpactForecastingGraph from "./ImpactForecastingGraph";
import ComparativeMetricsTable from "./ComparativeMetricsTable";

import DummyData from "../../constants/dashboard.json";
import { useMutation } from "@tanstack/react-query";
import { getIndustryDetails } from "../../services/sectorIndustryService";

const initialCharts = [
  // {
  //   id: "1",
  //   content: (
  //     <Card hoverable bordered className={classes.customCard}>
  //       <DragOutlined className={classes.customDrag} />

  //       <div className={classes.graphHeader}>
  //         <span className={classes.title}>Radar Chart Overview</span>
  //         <span className={classes.subTitle}>Lorem ipsum is a dummy text</span>
  //       </div>
  //       <PolarChart />
  //     </Card>
  //   ),
  //   sm: 24,
  //   md: 12,
  // },
  // {
  //   id: "2",
  //   content: (
  //     <Card hoverable bordered className={classes.customCard}>
  //       <DragOutlined className={classes.customDrag} />

  //       <div className={classes.graphHeader}>
  //         <span className={classes.title}>Radar Chart Overview</span>
  //         <span className={classes.subTitle}>Lorem ipsum is a dummy text</span>
  //       </div>
  //       <PolarChart />
  //     </Card>
  //   ),
  //   sm: 24,
  //   md: 12,
  // },
  {
    id: "3",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />
        <div className={classes.cardHeader}>
          <div className={classes.graphHeader}>
            <span className={classes.title}>In Progress Scenarios</span>
            <span className={classes.subTitle}>
              Lorem ipsum is a dummy text
            </span>
          </div>
          <span className={classes.positivePercentage}>
            <ArrowUpOutlined /> 28%
          </span>
        </div>
        <div className={classes.progressContainer}>
          <Progress
            type="circle"
            steps={0}
            percent={80}
            trailColor="rgba(0, 0, 0, 0.06)"
            strokeWidth={15}
            size={100}
          />
        </div>
      </Card>
    ),
    sm: 12,
    md: 6,
  },
  {
    id: "4",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />

        <div className={classes.cardHeader}>
          <div className={classes.graphHeader}>
            <span className={classes.title}>Completed Scenarios</span>
            <span className={classes.subTitle}>
              Lorem ipsum is a dummy text
            </span>
          </div>
          <span className={classes.positivePercentage}>
            {" "}
            <ArrowUpOutlined /> 58%
          </span>
        </div>
        <div className={classes.progressContainer}>
          <Progress
            type="circle"
            steps={0}
            percent={50}
            trailColor="rgba(0, 0, 0, 0.06)"
            strokeWidth={15}
            size={100}
            strokeColor={"#52C41A"}
          />
        </div>
      </Card>
    ),
    sm: 12,
    md: 6,
  },
  {
    id: "5",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />

        <div className={classes.cardHeader}>
          <div className={classes.graphHeader}>
            <span className={classes.title}>Pending Scenarios</span>
            <span className={classes.subTitle}>
              Lorem ipsum is a dummy text
            </span>
          </div>
          <span className={classes.positivePercentage}>
            {" "}
            <ArrowUpOutlined /> 12%
          </span>
        </div>
        <div className={classes.progressContainer}>
          <Progress
            type="circle"
            steps={0}
            percent={28}
            trailColor="rgba(0, 0, 0, 0.06)"
            strokeWidth={15}
            size={100}
            strokeColor={"#faad14"}
          />
        </div>
      </Card>
    ),
    sm: 12,
    md: 6,
  },
  {
    id: "6",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />

        <div className={classes.cardHeader}>
          <div className={classes.graphHeader}>
            <span className={classes.title}>Rejected Scenarios</span>
            <span className={classes.subTitle}>
              Lorem ipsum is a dummy text
            </span>
          </div>
          <span className={classes.negativePercentage}>
            {" "}
            <ArrowDownOutlined /> 10%
          </span>
        </div>
        <div className={classes.progressContainer}>
          <Progress
            type="circle"
            steps={0}
            percent={10}
            trailColor="rgba(0, 0, 0, 0.06)"
            strokeWidth={15}
            size={100}
            strokeColor={"#FF4D4F"}
          />
        </div>
      </Card>
    ),
    sm: 12,
    md: 6,
  },
  {
    id: "7",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />

        <div className={classes.graphHeader}>
          <span className={classes.title}>Trending Topics</span>
          <span className={classes.subTitle}>
            Shows real-time trending keywords or topics within the user’s
            industry, with brief summaries.
          </span>
        </div>
        <BarChart />
      </Card>
    ),
    sm: 24,
    md: 12,
  },
  {
    id: "8",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />

        <div className={classes.graphHeader}>
          <span className={classes.title}>Radial Overview</span>
          <span className={classes.subTitle}>Lorem ipsum is a dummy text</span>
        </div>
        <RadialBarChart />
      </Card>
    ),
    sm: 24,
    md: 12,
  },
  {
    id: "9",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />

        <div className={classes.graphHeader}>
          <span className={classes.title}>Area Chart Overview</span>
          <span className={classes.subTitle}>Lorem ipsum is a dummy text</span>
        </div>
        <AreaChart />
      </Card>
    ),
    sm: 24,
    md: 24,
  },
  {
    id: "10",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />

        <div className={classes.graphHeader}>
          <span className={classes.title}>Competitor Trend Analysis</span>
          <span className={classes.subTitle}>
            Highlights trends that competitors are engaging with, showing what
            might be working in their favor.
          </span>
        </div>
        <CompetitorTrendChart />
      </Card>
    ),
    sm: 24,
    md: 24,
  },
  {
    id: "11",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />

        <div className={classes.graphHeader}>
          <span className={classes.title}>Market Sentiment Analysis</span>
          <span className={classes.subTitle}>
            Uses sentiment analysis to monitor public perception around trending
            topics in the user’s industry.
          </span>
        </div>
        <MarketSentimentChart />
      </Card>
    ),
    sm: 24,
    md: 24,
  },
  {
    id: "12",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />

        <div className={classes.graphHeader}>
          <span className={classes.title}>Emerging Risks & Opportunities</span>
          <span className={classes.subTitle}>
            Lists new trends that have recently emerged, categorized as
            potential risks or opportunities.
          </span>
        </div>
        <EmergingTrendsChart />
      </Card>
    ),
    sm: 24,
    md: 24,
  },
  {
    id: "13",
    content: (
      <Card hoverable bordered className={classes.customCard}>
        <DragOutlined className={classes.customDrag} />

        <div className={classes.graphHeader}>
          <span className={classes.title}>Impact Heatmap</span>
          <span className={classes.subTitle}>
            Visual heatmap of current trends, with colors indicating potential
            impact levels (e.g., red for high impact).
          </span>
        </div>
        <HeatmapChart />
      </Card>
    ),
    sm: 24,
    md: 24,
  },
];

function Dashboard() {
  const navigate = useNavigate();
  const sectors = useSelector((state) => state.sectors);
  const [selectedRowKeys, setSelectedRowKeys] = useState(["basic-materials"]);

  const [charts, setCharts] = useState(initialCharts);
  const [selectedCharts, setSelectedCharts] = useState([]);
  const [selectedSector, setSelectedSector] = useState(null);
  const [defaultSectorDetails, setDefaultSectorDetails] = useState({
    sectorsCount: "-",
    industriesCount: "-",
    marketCap: "-",
    sectorDescription:
      "Sectors represent large sections of the economy and include multiple companies. Explore different sector performances below to analyze the economy as a whole.",
  });

  const getIndustryDetailsMutation = useMutation({
    mutationFn: getIndustryDetails,
    onSuccess: (data) => {},
  });

  // Function to handle the drag and drop logic
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(charts);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setCharts(items);
  };

  const options = [
    { value: "7", label: "Trending Topics" },
    { value: "10", label: "Competitor Trend Analysis" },
    { value: "11", label: "Market Sentiment Analysis" },
    { value: "12", label: "Emerging Risks & Opportunities" },
    { value: "13", label: "Impact Heatmap" },

    { value: "3", label: "In Progress Scenarios" },
    { value: "4", label: "Completed Scenarios" },
    { value: "5", label: "Pending Scenarios" },
    { value: "6", label: "Rejected Scenarios" },
    { value: "1", label: "Radial 01" },
    { value: "2", label: "Radial 02" },
    { value: "8", label: "Radial Overview" },
    { value: "9", label: "Area Chart Overview" },
  ];

  const handleChange = (value) => {
    setSelectedCharts(value);
  };

  const handleSelectItem = (item) => {
    console.log(item);
  };

  const handleGoToSector = () => {
    if (selectedSector)
      navigate(`/home/sectors-details/${selectedSector.sector_key}`);
    else if (selectedRowKeys.length)
      navigate(`/home/sectors-details/${selectedRowKeys[0]}`);
    else return;
  };

  const handleUpdateState = (selectedSector) => {
    setDefaultSectorDetails({
      sectorsCount: "",
      industriesCount: selectedSector.industries?.length ?? 0,
      marketCap: formatToTrillions(selectedSector.overview.market_cap),
      sectorDescription: selectedSector.overview.description,
    });
    getIndustryDetailsMutation.mutate({
      sector: "",
      industry_name: selectedSector.sector_key,
    });
  };

  const handleSelectAllSectors = () => {
    setDefaultSectorDetails({
      sectorsCount: sectors.length,
      industriesCount: sectors.reduce(
        (acc, sector) => acc + sector.overview.industries_count,
        0
      ),
      marketCap: formatToTrillions(
        sectors.reduce((acc, sector) => acc + sector.overview.market_cap, 0)
      ),
      sectorDescription:
        "Sectors represent large sections of the economy and include multiple companies. Explore different sector performances below to analyze the economy as a whole.",
    });
  };

  useEffect(() => {
    if (sectors && sectors.length) {
      handleSelectAllSectors();
    }
  }, [sectors]);

  useEffect(() => {
    getIndustryDetailsMutation.mutate({
      sector: "",
      industry_name: "basic-materials",
    });
  }, []);

  const allSectors = [
    {
      name: "All Sectors",
      overview: {
        market_weight:
          sectors?.reduce(
            (acc, sector) => acc + sector.overview.market_weight,
            0
          ) ?? 0,
        industries_count:
          sectors?.reduce(
            (acc, sector) => acc + sector.overview.industries_count,
            0
          ) ?? 0,
        companies_count:
          sectors?.reduce(
            (acc, sector) => acc + sector.overview.companies_count,
            0
          ) ?? 0,
      },
    },
  ];

  const { data: industryDetail } = getIndustryDetailsMutation?.data?.data
    ?.results?.[0] || { data: {} };

  return (
    <div>
      <Select
        title="Select Charts"
        mode="tags"
        placeholder="Please select charts to display"
        value={selectedCharts}
        onChange={handleChange}
        options={options}
        style={{ width: "100%", marginBottom: 20 }}
      />
      {/* <div className={classes.customCard}>
        <div className={classes.headerContent}>
          <div className={classes.header}>
            <span className={classes.selectSector}>Sectors</span>
            <span className={classes.pageSubTitle}>
              {defaultSectorDetails.sectorDescription}
            </span>
          </div>
          <div>
            <div className={classes.cardWrapper}>
              {defaultSectorDetails.sectorsCount && (
                <div className={classes.card}>
                  <h5 className={classes.cardTitle}>Sectors</h5>
                  <span className={classes.cardContent}>
                    {defaultSectorDetails.sectorsCount}
                  </span>
                </div>
              )}
              <div className={classes.card}>
                <h5 className={classes.cardTitle}>Industries</h5>
                <span className={classes.cardContent}>
                  {defaultSectorDetails.industriesCount}
                </span>
              </div>
              <div className={classes.card}>
                <h5 className={classes.cardTitle}>Market Cap</h5>
                <span className={classes.cardContent}>
                  {defaultSectorDetails.marketCap}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.headerContent}>
          <div className={classes.header}>
            <span className={classes.selectSector}>Current Status</span>
            <span className={classes.pageSubTitle}>
              {industryDetail?.overview_status?.current_status || ""}
            </span>
            <span className={classes.selectSector}>Key Highlights</span>
            <Flex gap="4px 0" wrap style={{ marginBottom: 10 }}>
              {industryDetail?.overview_status?.key_highlights?.map(
                (highlight) => {
                  return <Tag color="blue">{highlight}</Tag>;
                }
              )}
            </Flex>
          </div>
        </div>
        <div className={classes.chartContainer}>
          <span className={classes.selectSector}>
            Select a Sector for a Visual Breakdown
          </span>
          {(selectedSector || selectedRowKeys?.length) && (
            <Button
              type="primary"
              size="small"
              onClick={handleGoToSector}
              style={{ alignSelf: "flex-start" }}
            >
              Go to Sector
            </Button>
          )}
        </div>
        <Row style={{ alignItems: "center" }}>
          <Col md={12} sm={24}>
            <PolarChart
              handleSelectItem={handleSelectItem}
              dynamicDots={industryDetail?.overview_status}
            />
          </Col>
          <Col md={12} sm={24}>
            <Table
              columns={columns}
              dataSource={[...allSectors, ...sectors] ?? []}
              size="small"
              pagination={false}
              rowKey="sector_key"
              rowSelection={{
                type: "radio",
                selectedRowKeys,
                onChange: (keys, selectedRows) => {
                  setSelectedRowKeys(keys);
                  if (
                    selectedRows.length > 0 &&
                    selectedRows[0].name !== "All Sectors"
                  ) {
                    setSelectedSector(selectedRows[0]);
                    handleUpdateState(selectedRows[0]);
                    return;
                  }
                  setSelectedSector(null);
                  handleSelectAllSectors();
                },
              }}
            />
          </Col>
        </Row>
      </div> */}
      {/* <div bordered className={classes.customCard}>
        <Row>
          <Col md={12} sm={24}>
            <RiskSummaryChart
              dataSource={industryDetail?.overview_status?.risk_summary}
            />
          </Col>
          <Col md={12} sm={24}>
            <OpportunitySummaryChart
              dataSource={industryDetail?.overview_status?.opportunity_summary}
            />
          </Col>
          <Col md={24} sm={24}>
            <ImpactForecastingGraph
              dataSource={industryDetail?.impact_forecasting_graph}
            />
          </Col>
          <Col md={24} sm={24}>
            <ComparativeMetricsTable
              dataSource={industryDetail?.comparative_metrics_dashboard}
            />
          </Col>
        </Row>
      </div> */}
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="charts" direction="horizontal">
          {(provided) => (
            <Row
              gutter={[16, 16]}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {charts
                .filter((c) => selectedCharts.includes(c.id))
                .map((chart, index) => (
                  <Draggable
                    key={chart.id}
                    draggableId={chart.id}
                    index={index}
                  >
                    {(provided) => (
                      <Col
                        sm={chart.sm}
                        md={chart.md}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        {chart.content}
                      </Col>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </Row>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}

export default Dashboard;
